module.exports = __webpack_public_path__ + "static/media/logo.7983dd84.svg";